import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatBadgeNumberPipe } from './format-badge-number.pipe';



@NgModule({
  declarations: [
    FormatBadgeNumberPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FormatBadgeNumberPipe
  ]
})
export class FormatBadgeNumberModule { }
